module.exports = __webpack_public_path__ + "img/AI智能路灯2.8c85b6b6.jpg";